var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.276 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 237",
    fill: "#0056e5"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1430",
    d: "m.2 12.531-.01-.01a.374.374 0 0 1-.039-.054s0-.01-.01-.015-.025-.039-.034-.059a.017.017 0 0 0 0-.01c-.01-.02-.02-.039-.029-.064v-.01c0-.01-.015-.044-.025-.069v-.01a.344.344 0 0 1-.015-.069.044.044 0 0 0 0-.025c0-.02 0-.039-.01-.059a.71.71 0 0 1 0-.167.246.246 0 0 1 .01-.059.044.044 0 0 1 0-.024c0-.024.01-.044.015-.069v-.01a.385.385 0 0 1 .025-.069s0 0 0-.01.02-.044.029-.064a.017.017 0 0 1 0-.01.364.364 0 0 1 .034-.059s0-.01.01-.015a.512.512 0 0 1 .039-.054l.01-.01a.694.694 0 0 1 .059-.064l4.845-4.84a.842.842 0 0 1 1.19 1.19l-3.41 3.41h13.555a.84.84 0 1 1 0 1.68H2.879l3.385 3.385a.84.84 0 1 1-1.186 1.19L.262 12.592a.4.4 0 0 1-.062-.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1431",
    d: "M17.714 1.68h-6.27a.84.84 0 1 1 0-1.68h6.271a4.568 4.568 0 0 1 4.561 4.561v14.878A4.568 4.568 0 0 1 17.714 24h-6.168a.84.84 0 1 1 0-1.68h6.168a2.885 2.885 0 0 0 2.881-2.881V4.561a2.885 2.885 0 0 0-2.881-2.881Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.56dc90b1f3e98b103ab70be6f827504e.svg";
export { ForwardRef as ReactComponent };